import { useEffect, useRef, useState } from "react";

export function useWorkspaceMenu() {
	const [menuOpenId, setMenuOpenId] = useState<string | null>(null);
	const menuRef = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		if (!menuOpenId) return;
		const handleOutside = (e: MouseEvent) => {
			if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
				setMenuOpenId(null);
			}
		};
		const t = setTimeout(() => document.addEventListener("mousedown", handleOutside));
		return () => {
			clearTimeout(t);
			document.removeEventListener("mousedown", handleOutside);
		};
	}, [menuOpenId]);

	return { menuOpenId, setMenuOpenId, menuRef };
}
